<template>

    <div class="lfg">

        <div class="header">
            <div class="side">
                <button @click="$emit('previous')">
                    <img src="/img/login/google/chevron-left.svg">
                    <span v-show="isDesktop">{{ $t('global_back') }}</span>
                </button>
            </div>
            <div class="title-header">
                <img src="/img/login/google/Logo.svg" @click="goLanding" class="logo">
            </div>
            <div class="side"></div>
        </div>

        <div class="background">

            <div class="bloc">

                <div class="steps" v-if="showSteps">

                    <div class="red-line" v-show="!isDesktop">
                        <div class="alabasta">
                            <div class="alubarna">
                                <div class="nanohana">
                                    <div class="line"></div>
                                    <div class="line line-pending" :style="linePending"></div>
                                    <div class="line line-completed" v-show="isLogin"></div>
                                </div>
                            </div>
                        </div>
                        <div class="skypiea">
                            <div class="isle" v-for="(tab, tabIndex) in steps">
                                <img
                                    :src="tabIndex === stepIndex ? '/img/login/google/arrow.svg' : tabIndex < stepIndex ? '/img/login/google/check.svg' : '/img/login/google/circle-grey.svg'"
                                    class="circle">
                                <span :class="{
                                    active: tabIndex === stepIndex,
                                    validated: tabIndex < stepIndex
                                    }">{{
                                        $t(`google_flow_${tabIndex + 1}step`)
                                    }}</span>
                            </div>
                        </div>

                    </div>
                    <div v-show="isDesktop" class="tabs">
                        <div v-for="(tab, tabIndex) in steps" class="tab"
                             :class="{'tab-pending': tabIndex === stepIndex, 'tab-completed': tabIndex < stepIndex}"
                             @click="clickTab(tabIndex)">
                            <img src="/img/login/google/check.svg" v-show="tabIndex < stepIndex">
                            <span>{{ tab.title }}</span>
                        </div>
                    </div>

                </div>

                <div class="content" :class="{'content-naver': isNaver}">

                    <slot name="body"></slot>

                </div>

                <div class="footer">

                    <slot name="footer"></slot>

                </div>


            </div>

        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

export default {

    name: 'login-flow-complex-container',

    props: {
        showSteps: {
            type: Boolean,
            default: true
        },
        steps: {
            type: Array,
            default: () => []
        },
        stepIndex: {
            type: Number,
            default: 0
        },
    },

    computed: {

        ...Vuex.mapGetters(['lang']),


        isLogin() {
            return !!(this.step && this.step.isLogin)
        },
        error() {
            return this.errorCountCharacters || this.errorConnection
        },
        errorMessage() {
            return this.errorCountCharacters ? this.$t('google_flow_error') : this.$t('login_error_invalid_email_password')
        },
        step() {
            return this.steps[this.stepIndex]
        },
        linePending() {
            return `width: ${((this.stepIndex) / (this.steps.length - 1)) * 100}%;`
        },
        isNaver() {
            return this.provider === 'naver'
        }

    },

    data() {
        return {}
    },

    methods: {


        goLanding() {
            this.$router.push({path: '/'})
        },

        clickTab(tabIndex) {
            this.$emit('clickTab', tabIndex + 1)
        }
    }
}
</script>

<style lang="scss" scoped>


.lfg {
    display: flex;
    flex-direction: column;
    flex: 1;

    .header {
        padding: 16px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.12);
        backdrop-filter: blur(10px);
        @media screen and (min-width: $above-tablet-length) {
            padding: 24px 32px;
        }

        .side {
            min-width: 24px;

            @media screen and (min-width: $above-tablet-length) {
                flex: 1;
            }

            &:lang(ar-sa) {
                transform: rotate(180deg);
            }

            button {
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $white;
                font-size: 17px;
                font-weight: 600;
                line-height: 24px;
                color: $aquamarine;
                text-align: start;

                &:lang(ar-sa) {
                    flex-direction: row-reverse;
                }

                > img {
                    @media screen and (min-width: $above-tablet-length) {
                        margin-right: 4px;
                    }
                }
            }
        }

        .title-header {
            flex: 1;
            display: flex;
            justify-content: center;
            cursor: pointer;


            .logo {
                height: 16px;
                @media screen and (min-width: $above-tablet-length) {
                    height: 24px;
                }
            }
        }
    }

    .background {
        flex: 1;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-tablet-length) {
            background-color: #E0F1FC;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .bloc {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 100%;
            text-align: start;
            @media screen and (min-width: $above-tablet-length) {
                background-color: $white;
                max-width: 720px;
                border-radius: 32px;
                overflow: hidden;
                flex: initial;
            }

            .steps {
                padding: 16px;

                @media screen and (min-width: $above-tablet-length) {
                    padding: 0
                }

                .red-line {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    position: relative;

                    .skypiea {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;


                        .isle {
                            display: flex;
                            flex-direction: column;
                            align-items: center;

                            .circle {
                                width: 24px;
                                object-fit: contain;
                                z-index: 1;
                            }

                            .active {
                                font-weight: 600;
                            }

                            .validated {
                                color: $forest;
                            }
                        }
                    }

                    .alabasta {
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                        padding: 10px 30px 0;

                        .alubarna {
                            position: absolute;
                            height: 2px;
                            margin-left: 36px;
                            margin-right: 36px;
                            left: 0;
                            right: 0;

                            .nanohana {
                                position: relative;
                                height: 2px;

                                .line {
                                    width: 100%;
                                    height: 2px;
                                    background-color: $neutralsPlatinum;
                                    position: absolute;

                                }

                                .line-pending {
                                    //full compatibility
                                    background: rgb(94, 167, 116);
                                    background: -moz-linear-gradient(90deg, rgba(94, 167, 116, 1) 20%, rgba(50, 163, 235, 1) 80%);
                                    background: -webkit-linear-gradient(90deg, rgba(94, 167, 116, 1) 20%, rgba(50, 163, 235, 1) 80%);
                                    background: linear-gradient(90deg, rgba(94, 167, 116, 1) 20%, rgba(50, 163, 235, 1) 80%);
                                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5ea774", endColorstr="#32a3eb", GradientType=1);
                                }

                                .line-completed {
                                    background-color: $forest;
                                    width: 100%;
                                }
                            }
                        }
                    }
                }

                .tabs {
                    display: flex;
                    flex-direction: row;
                    font-size: 17px;
                    font-weight: 400;
                    line-height: 24px;
                    color: $neutralsMoon;


                    .tab {
                        padding: 16px;
                        flex: 1;
                        background-color: $timberwolf;
                        display: flex;
                        align-items: center;

                        > img {
                            width: 20px;
                            object-fit: contain;
                            margin-right: 12px;

                            &:lang(ar-sa) {
                                margin: 0 0 0 12px;
                            }
                        }

                        > span {
                            flex: 1;
                            text-align: center;
                        }


                    }

                    .tab-pending {
                        color: $charcoal;
                        font-weight: 500;
                        background-color: $white;

                        > span {
                            font-weight: 600;
                        }
                    }

                    .tab-completed {
                        color: $forest;
                        background-color: $white;
                        text-align: start;
                        cursor: pointer;
                    }

                    .next-tab {
                        text-align: center;
                        border-bottom-left-radius: 24px;

                        &:lang(ar-sa) {
                            border-bottom-right-radius: 24px;
                            border-bottom-left-radius: 0;
                        }
                    }
                }

            }

        }
    }

    .content {
        flex: 1;
        margin-top: 45px;
        padding: 0 16px 100px;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-tablet-length) {
            padding: 0 80px;
        }
    }

    .footer {
        display: flex;
        flex-direction: row;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 8px 16px;
        box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.12);
        background-color: $white;

        @media screen and (min-width: $above-tablet-length) {
            position: relative;
            padding: 24px 80px 32px;
            box-shadow: none;
        }
    }
}

</style>
